import { Sorter } from '@process-creative/slate-ajax-collection';

const SEL_SORT_VALUES = '[data-sort-values]';
const SEL_SORT_INPUT = '[data-sort-input]';

export class CustomSelectSorter extends Sorter {
  constructor({ template, sortElem, sortMethods }) {
    super(template);
    this.template = template;
    this.sortElem = sortElem;
    this.sortId = sortElem.id;
    this.sortMethods = sortMethods;

    $(this.sortElem).on('change', SEL_SORT_INPUT, e => this.onSortChange(e));
  }


  onSortChange(e) {
    if (!e.target?.value) return console.warn('Invalid markup detected in the sort select box.');

    //Don't update if this is the same value as before, saves a redraw
    if (e.target.value === this.template.sort.getSortMethod()?.handle) return;

    this.template.sort.setSort(e.target.value);
  }

  onUpdate(selected) {
    const valuesElement = this.sortElem.querySelector(SEL_SORT_VALUES);
    if (!valuesElement) return;

    //If there's no selected value, reset to the default
    if (!selected) selected = this.template.sort.defaultSortBy.handle;

    const sortHtml = Object.entries(this.sortMethods).map(([key, value]) => {
      //Skip invalid elements
      if (!value || !value.isVisible) return '';
      if (!value.isVisible(this.template)) return '';

      //Is checked?
      const checked = selected.handle === value.handle;
      const id = `${value.handle}-${this.sortId}`;

      //Generate print.
      return `
        <li class="o-select-box__option">
          <input
            type="radio"
            name="collection-sort-${this.sortId}"
            id="${id}"
            value="${value.handle}"
            class="o-select-box__option-input"
            data-sort-input
            ${checked ? 'checked' : ''}
          />
          <label class="o-select-box__option-label o-type--2--caps" for="${id}">
            ${this.getOptionName(value, checked)}
          </label>
        </li>
      `;
    }).join('');

    valuesElement.innerHTML = sortHtml;
  }

}